
/* eslint-disable react/prop-types */
// @mui material components
import Alert from "@mui/material/Alert";

export default ({children, severity, sx }) => {
  return <Alert sx={{ marginBottom: '16px', alignItems: 'center', fontSize: '0.9rem', fontWeight: 500, lineHeight: 1, '& .MuiAlert-icon': { fontSize: '20px', opacity: 1, padding: '4px 0', marginRight: '10px' }, ...sx }} severity={severity}>{children}</Alert>
}
